import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=96bc32fc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=96bc32fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc32fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96bc32fc')) {
      api.createRecord('96bc32fc', component.options)
    } else {
      api.reload('96bc32fc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=96bc32fc&scoped=true&", function () {
      api.rerender('96bc32fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-49pmXpk2rXZLV/JS/comp/SearchFilterTokens.vue"
export default component.exports